module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top saveProductChanges",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "header": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('h2', {
    staticClass: "mb-4 text-center bold"
  }, [_vm._v("Do you want to replace in all events?")]), _vm._v(" "), _c('p', [_vm._v("\n                Some events may have been "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("manually edited in the calendar")]), _vm._v(", would you like the following information to be replaced in all events?\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_c('span', {
    staticClass: "bold",
    staticStyle: {
      "color": "#ff4545"
    }
  }, [_vm._v("Warning")]), _vm._v(" This operation may take some time if you have several schedules.\n            ")]), _vm._v(" "), _c('schedule-group-changes', {
    attrs: {
      "product": _vm.getClonedItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-4 pt-3 mt-3 border-top-light"
  }, [_c('radio', {
    attrs: {
      "name": "resetAll",
      "value": false
    },
    model: {
      value: (_vm.optionSelected),
      callback: function($$v) {
        _vm.optionSelected = $$v
      },
      expression: "optionSelected"
    }
  }, [_c('span', {
    staticClass: "darkest"
  }, [_vm._v("No, do not replace events edited directly in calendar.")])]), _vm._v(" "), _c('radio', {
    attrs: {
      "name": "resetAll",
      "value": true
    },
    model: {
      value: (_vm.optionSelected),
      callback: function($$v) {
        _vm.optionSelected = $$v
      },
      expression: "optionSelected"
    }
  }, [_c('span', {
    staticClass: "darkest"
  }, [_vm._v("Yes, apply changes to all events.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn tertiary",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "flexGrow1 text-right"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.optionSelected == null || _vm.getIsAddingItem
    },
    on: {
      "click": _vm.pressBtn
    }
  }, [_vm._v("Submit")])])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-07338d60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07338d60"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ProductSaveChanges.vue
// module id = 1520
// module chunks = 0